<script setup>
import {useStepManager} from "../../../Registration/stores/stepsManager";

const stepsManager = useStepManager();
const handleNavigateToStep = step => {
    stepsManager.setCurrentStep(step.id);
}
</script>

<template>
    <div class="steps-navigator-container relative w-full flex justify-center my-4 lg:px-10">
        <div class="w-full">
            <ol class="steps-container flex items-end justify-center list-none w-full">
                <li
                    v-for="step in stepsManager.steps"
                    :class="{'step-item-wrapper list-none w-[80px]': true, active: step.id === stepsManager.current.id, done: step.validation === 'success'}"
                    :key="`step-navigator-item-${step.id}`"
                >
                    <div class="flex flex-col items-center">
                        <span
                            class="step-item-label text-xs flex items-center justify-center text-center w-full mb-5 "

                        ><svg v-if="stepsManager.stepsWithError.includes(step.id)" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="currentColor" class="text-red-500 w-3 h-3 mr-1">
                        <path fill-rule="evenodd" d="M6.701 2.25c.577-1 2.02-1 2.598 0l5.196 9a1.5 1.5 0 0 1-1.299 2.25H2.804a1.5 1.5 0 0 1-1.3-2.25l5.197-9ZM8 4a.75.75 0 0 1 .75.75v3a.75.75 0 1 1-1.5 0v-3A.75.75 0 0 1 8 4Zm0 8a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z" clip-rule="evenodd" />
                    </svg>{{step.label}}</span>
                        <span class="step-order-wrapper w-full flex justify-center select-none">
                            <span @click.prevent="handleNavigateToStep(step)"
                                  :class="{'step-order-value flex h-10 w-10 items-center justify-center rounded-full': true, 'cursor-pointer': step.validation==='success'}">
                                <span v-text="step.order"></span>
                            </span>
                        </span>
                    </div>

                </li>
            </ol>
        </div>
    </div>

</template>

<style scoped>

</style>
